import { render, staticRenderFns } from "./InvoiceCreate.vue?vue&type=template&id=222a4798&scoped=true"
import script from "./InvoiceCreate.vue?vue&type=script&lang=js"
export * from "./InvoiceCreate.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCreate.vue?vue&type=style&index=0&id=222a4798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a4798",
  null
  
)

export default component.exports